<template>
  <div class="mobile-navigation custom MobNav-3" :class="{ open: isMobileNavigationOpen }" aria-labelledby="mobile-navigation-toggler" itemscope itemtype="https://schema.org/SiteNavigationElement">
    <div v-show="isNavigationInitialized">
      <ul class="breadcrumb d-block px-3 py-0">
        <li class="btn-close" @click="closeNavigation()" :aria-label="$translate('Ceres::Template.closeIcon')"></li>

        <li class="breadcrumb-item" @click="goTo(-1)">
          <i aria-hidden="true" class="fa fa-home"></i>
        </li>

        <li v-for="(breadcrumb, index) in breadcrumbs" class="breadcrumb-item" @click="goTo(index)">
          {{ breadcrumb.name }}
        </li>
      </ul>
      <ul id="menu-1" v-menu class="mainmenu w-100 p-0 m-0 menu-active">
        <li v-if="dataContainer1.parent" class="ddown" @click="slideTo(dataContainer1.parent || null, true)">
          <span class="nav-direction btn-up">
            <i aria-hidden="true" class="fa fa-lg fa-level-up"></i>
          </span>
        </li>

        <template v-if="dataContainer1.category && dataContainer1.category.children">
          <li v-for="(category, index) in dataContainer1.category.children" :key="index" class="ddown">
            <div :class="category.name" :data-index="index" :data-level="category.level" class="w-100 d-flex">
              <a :href="getCategoryUrl(category.url)" itemprop="name">{{ category.name }}</a>
              <span v-if="category.children && category.children.length > 0" class="nav-direction" @click="slideTo(category, false)">
                <i aria-hidden="true" class="fa fa-lg fa-caret-right"></i>
              </span>
            </div>
          </li>
        </template>
      </ul>

      <ul id="menu-2" v-menu class="mainmenu w-100 p-0 m-0">
        <li v-if="dataContainer2.parent" class="ddown" @click="slideTo(dataContainer2.parent || null, true)">
          <span class="nav-direction btn-up">
            <i aria-hidden="true" class="fa fa-lg fa-level-up"></i>
          </span>
        </li>

        <template v-if="dataContainer2.category && dataContainer2.category.children">
          <li v-for="(category, index) in dataContainer2.category.children" :key="index" class="ddown">
            <div class="w-100 d-flex">
              <a :href="getCategoryUrl(category.url)" itemprop="name">{{ category.name }}</a>
              <span v-if="category.children && category.children.length > 0" class="nav-direction" @click="slideTo(category, false)">
                <i aria-hidden="true" class="fa fa-lg fa-caret-right"></i>
              </span>
            </div>
          </li>
        </template>
      </ul>
    </div>

    <template v-if="!isNavigationInitialized">
      <ul class="breadcrumb">
        <li class="btn-close" @click="closeNavigation()" :aria-label="$translate('Ceres::Template.closeIcon')"></li>
        <li class="breadcrumb-item">
          <i aria-hidden="true" class="fa fa-home"></i>
        </li>
      </ul>

      <loading-animation></loading-animation>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { MediaQueryHelper } from "../../helper/MediaQueryHelper";
import { isNullOrUndefined } from "../../helper/utils";

import ApiService from "../../services/ApiService";

export default {
  props: {
    template: {
      default: "#vue-mobile-custom-navigation",
      type: String,
    },
    initialCategory: Object,
    breakpoints: {
      type: Array,
      default: () => ["xs", "sm", "md"],
    },
    includeLanguage: Boolean,
  },

  data() {
    return {
      dataContainer1: {
        parent: {},
        category: {},
      },
      dataContainer2: {
        parent: {},
        category: {},
      },
      categoryTree: [],
      breadcrumbs: [],
      useFirstContainer: false,
      isNavigationInitialized: false,
      selectedCategory: null,
    };
  },

  computed: {
    ...mapState({
      navigationTree: (state) => state.navigation.tree,
      isMobileNavigationOpen: (state) => state.navigation.isMobileNavigationOpen,
    }),
  },

  created() {
    this.$store.commit("setCurrentCategory", this.initialCategory);
  },

  mounted() {
    this.addEventListener();
  },

  methods: {
    addEventListener() {
      const QueryHelper = new MediaQueryHelper();
      const breakpoint = QueryHelper.getCurrentBreakpoint();

      QueryHelper.addFunction(this.loadInitialCategory, this.breakpoints);

      if (this.breakpoints.includes(breakpoint)) {
        this.loadInitialCategory();
      }
    },

    loadInitialCategory() {
      ApiService.get("/rest/io/category/description/15126", {
        description1: 1,
      })
        .done((response) => {
          this.categoryTree = JSON.parse(response.description1);
          this.dataContainer1.parent = null;
          this.dataContainer1.category = this.categoryTree;
          this.isNavigationInitialized = true;
        })
        .fail(() => {
          return null;
        });
    },

    slideTo(category, back) {
      if (category.level === 1) {
        this.selectedCategory = category;
      }
      if (category.level !== 0 && !back) {
        this.breadcrumbs.push(category);
      }

      if (this.useFirstContainer) {
        this.dataContainer1.parent = this.dataContainer2.category;
        this.dataContainer1.category = category || [];

        if (back) {
          this.breadcrumbs.pop();
          this.dataContainer1.parent = this.getParentCategories(category);
        }

        $("#menu-2").trigger("menu-deactivated", { back: !!back });
        $("#menu-1").trigger("menu-activated", { back: !!back });
      } else {
        this.dataContainer2.parent = this.dataContainer1.category;
        this.dataContainer2.category = category || [];

        if (back) {
          this.breadcrumbs.pop();
          this.dataContainer2.parent = this.getParentCategories(category);
        }

        $("#menu-1").trigger("menu-deactivated", { back: !!back });
        $("#menu-2").trigger("menu-activated", { back: !!back });
      }

      // Nur neue Daten laden, wenn die Kategorie noch keine Kinder hat oder explizit als nicht geladen markiert ist
      if (!isNullOrUndefined(category.categoryId) && (!category.children || category.children.length === 0) && category.loaded === false) {
        this.loadPartialTree(category, this.useFirstContainer);
      }

      this.useFirstContainer = !this.useFirstContainer;
    },

    getParentCategories(category) {
      if (category.level >= 1) {
        let parentCategory = this.categoryTree;
        let counter = 0;

        while (counter < category.parentLevel - 1) {
          parentCategory = parentCategory.children[0];
          counter++;
        }
        return parentCategory;
      } else {
        return null;
      }
    },

    goTo(index) {
      if (index >= 0) {
        let category = this.breadcrumbs[index];
        this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
        this.breadcrumbs.push("");
        this.slideTo(category, true);
      } else {
        this.breadcrumbs = [];
        this.slideTo(this.categoryTree, true);
      }
    },

    loadPartialTree(category, useFirstContainer) {
      ApiService.get("/rest/io/categorytree/children", {
        categoryId: category.categoryId,
      })
        .done((response) => {
          category["loaded"] = true;
          if (useFirstContainer) {
            this.dataContainer1.category.children = response;
          } else {
            this.dataContainer2.category.children = response;
          }
        })
        .fail(() => {
          return null;
        });
    },

    getCategoryUrl(url) {
      if (url) {
        const trailingSlash = url[0] === "/" ? "" : "/";
        const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

        return prefix + url;
      }
      return "";
    },

    closeNavigation() {
      this.$store.commit("setIsMobileNavigationOpen", false);
    },
  },

  directives: {
    menu: {
      bind(el) {
        // add "activated" classes when menu is activated
        $(el).on("menu-activated", (event, params) => {
          $(event.target).addClass("menu-active");
          $(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
        });
        // add "deactivated" classes when menu is deactivated
        $(el).on("menu-deactivated", (event, params) => {
          $(event.target).removeClass("menu-active");
          $(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
        });
        // this removes the animation class automatically after the animation has completed
        $(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () => {
          $(".mainmenu").removeClass((index, className) => {
            return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
          });
        });
      },
    },
  },
};
</script>
